import React, { Component } from "react";
import config from "../../config";
import { Card, Jumbotron, Col, Form, Button, Table } from "react-bootstrap";
import errores from "../../middleware/errordb";
import Mensajes from "../subcomponent/mensajes";

import ModalConfirm from "../subcomponent/modalConfirm";
import funciones from '../../middleware/funciones'
import { concepts_payroll } from "./localdata/conceptos";

export class HomologacionNomina extends Component {
  constructor(props) {
    super(props);

    const currentCompany = sessionStorage.getItem("company");
    //const currentUserType = sessionStorage.getItem("tipo");
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!mm
    const yyyy = today.getFullYear();
    const todayFormat = yyyy + "-" + mm + "-" + dd;
    this.state = {
      evento: 1,
      fecha: todayFormat,
      codigo: "0",
      erp_code: "",
      descripcion: "",
      mostrarMensaje: false,
      empresa: currentCompany,
      homologacionNomina: [],
      code_erp: "",
      mensaje: "",
      textButton: "Crear Homologacion",
    };
  }

  componentDidMount() {
    this.infoHomologacion();
  }

  infoHomologacion = () => {
    const empresaEdicion = this.state.empresa;
    if (empresaEdicion) {
      const datasend = {
        method: "GET",

        headers: {
          "Content-Type": "application/json",
          empresa: this.state.empresa,
          tipo: this.state.tipo,
        },
      };
      fetch(config.servBackEnd + "/payroll/homologation", datasend)
        .then((response) => response.json())
        .then((data) => {
          if (data.ok) {
            console.log(data);
            const homologacionNomina = data.data;
            this.setState({ homologacionNomina });
          } else {
            this.setState({
              mostrarMensaje: true,
              mensaje: "Sin homologaciones creados",
            });
          }
        });
    }
  };

  createLine = (event) => {
    event.preventDefault();
    this.setState({ show: true });
  };

  enviarInfo = () => {
    this.setState({ show: false });
    event.preventDefault();
    const { evento } = this.state;
    const { erp_code } = this.state;
    const { descripcion } = this.state;
    const { gtic_code } = this.state;
    const { empresa } = this.state;
    const { codigo } = this.state;

    const datasend = {
      method: "POST",
      body: JSON.stringify({
        ID_EMPRESA: empresa,
        ERP_CODE: (erp_code || "").trim(),
        DESCRIPCION: (descripcion || "").trim(),
        GTIC_CODE: gtic_code,
      }),
      headers: {
        "Content-Type": "application/json",
        tipo: this.state.tipo,
        empresa: this.state.empresa,
      },
    };
    let url = "";
    if (evento) {
      url = "/payroll/homologation/create/";
    } else {
      url = "/payroll/homologation/modify/" + codigo;
    }
    fetch(config.servBackEnd + url, datasend)
      .then((response) => response.json())
      .then((data) => {
        if (data.ok) {
          this.infoHomologacion();
          this.setState({
            mostrarMensaje: true,
            mensaje: `Tarea Finalizada correctamente. Se actualizaron ${data.detail_updated || 0} detalles`,
            descripcion: "",
            estado: "1",
            code_erp: "",
            gtic_code: "",
            evento: 1,
            textButton: "Crear Homologacion",
          });
        } else {
          this.setState({
            mostrarMensaje: true,
            mensaje:
              "Error en Tipo de inventario: " +
              errores[data.code] +
              " " +
              data.message,
          });
        }
      });
  };

  edittype = (selected) => {
    this.setState({
      codigo: selected.ID_HOMOLOGACION_NOMINA,
      descripcion: selected.DESCRIPCION || "",
      erp_code: selected.ERP_CODE,
      gtic_code: selected.GTIC_CODE,
      evento: 0,
      textButton: "Modificar Homologacion",
    });
  };
  cleanForm = () => {
    //const { controlCodigo } = this.state;
    this.setState({
      codigo: "0",
      descripcion: "",
      erp_code: "",
      gtic_code: "",
      textButton: "Crear Concepto",
    });
  };

  handleClose = () => {
    this.setState({ show: false });
  };

  render() {
    const { homologacionNomina } = this.state;
    const edittype = this.edittype;
    const mensajeConfirm = this.state.evento
      ? "¿Está seguro que desea crear línea de inventario?"
      : "¿Está seguro que desea modificar la línea de inventario?";
    return (
      <div>

        <div>
          <ModalConfirm
            show={this.state.show}
            enviarInfo={this.enviarInfo}
            handleClose={this.handleClose}
            mensaje={mensajeConfirm}
          ></ModalConfirm>
        </div>
        <Jumbotron className="Jumbotron">
          <h2>Homologaciones</h2>
        </Jumbotron>
        <div>
          <Card className="card">
            <Card.Body>
              <Form className="form" onSubmit={this.createLine}>
                <Form.Row>
                  <Form.Group as={Col} controlId="">
                    <Form.Label>Codigo Concepto</Form.Label>
                    <Form.Control
                      type="text"
                      onChange={(e) =>
                        this.setState({
                          erp_code: e.target.value.toUpperCase(),
                        })
                      }
                      value={this.state.erp_code}
                      required
                    />
                  </Form.Group>
                  <Form.Group as={Col} controlId="">
                    <Form.Label>Descripcion</Form.Label>
                    <Form.Control
                      type="text"
                      onChange={(e) =>
                        this.setState({
                          descripcion: e.target.value.toUpperCase(),
                        })
                      }
                      value={this.state.descripcion}
                      required
                    />
                  </Form.Group>
                  <Form.Group as={Col} controlId="formGridbase">
                    <Form.Label>Codigo DIAN</Form.Label>
                    <Form.Control
                      as="select"
                      onChange={(e) =>
                        this.setState({ gtic_code: e.target.value })
                      }
                      value={this.state.gtic_code}
                      required
                    >
                      <option value="">--Seleccione--</option>
                      {
                        concepts_payroll.map((concept) => <option key={concept.code} value={concept.code} >{concept.description}</option>)
                      }
                    </Form.Control>
                  </Form.Group>
                </Form.Row>
                {!this.state.evento && (
                  <Button
                    className="m-3"
                    variant="primary"
                    onClick={this.cleanForm}
                  >
                    Limpiar
                  </Button>
                )}
                <Button className="m-3" variant="primary" type="submit">
                  {this.state.textButton}
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </div>
        <div className="tableFixHead">
          <Table bordered hover>
            <thead>
              <tr>
                <th>Empresa</th>
                <th>Codigo Concepto</th>
                <th>Descripcion Concepto</th>
                <th>Codigo DIAN</th>
                <th colSpan="2">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {homologacionNomina.map(function (currentData, index) {
                return (
                  <tr key={index + "d0"}>
                    <td>{currentData.ID_EMPRESA}</td>
                    <td>{currentData.ERP_CODE}</td>
                    <td>{currentData.DESCRIPCION || ""}</td>
                    <td>{funciones.homologacionDescription(currentData.GTIC_CODE || "")}</td>
                    <td>
                      <Button
                        onClick={() => edittype(currentData)}
                        variant="outline-primary"
                      >
                        Editar
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
        <Mensajes
          estado={this.state.mostrarMensaje}
          mensaje={this.state.mensaje}
          ocultar={() => this.setState({ mostrarMensaje: false })}
        ></Mensajes>
      </div>
    );
  }
}

export default HomologacionNomina;



// WEBPACK FOOTER //
// ./src/components/nomina/homologacion.jsx